import { render, staticRenderFns } from "./SinConexion.vue?vue&type=template&id=0fd9cbb4"
import script from "./SinConexion.vue?vue&type=script&lang=js"
export * from "./SinConexion.vue?vue&type=script&lang=js"
import style0 from "./SinConexion.vue?vue&type=style&index=0&id=0fd9cbb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports